<template>
  <div class="customers">
    <v-container class="pa-2">
      <template>
        <v-card class="d-flex-column ma-2">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Καρτέλες</h1>
            <v-spacer/>
            <v-chip label outlined>
              {{ creditBalance }}
            </v-chip>
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="customers"
              :search="search"
              loading: false
              item-key="info.name"
              class="elevation-0"
              :loading="loading"
              loading-text="Loading... Please wait"
              @click:row="clickrow"
              :height="$vuetify.breakpoint.height*0.6"
              show-select
              @item-selected="itemSelected"
              @toggle-select-all="itemSelectAll"
            >
            <template v-slot:item.status="{ item }">
              <v-chip :color="getColor(item.status)" dark>
                {{ item.status }}
              </v-chip>
            </template>

           
            <template v-slot:item.Balance="{ item }">
              {{ tocurr(item.Balance) }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <tr>
                <td :colspan="headers.length">
                  More info about {{ item.name }}
                </td>
              </tr>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                class="mr-2"
                icon
                small
                :to="'books/' + item.Id + '/repairs'"
              >
                <v-icon>mdi-information-variant</v-icon>
              </v-btn>
              <v-btn
                class="mr-2"
                icon
                small
                @click.stop="getBook(item.customer_id)"
              >
                <v-icon>mdi-microsoft-excel</v-icon>
              </v-btn>
            </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import { sumBy as _sumBy } from 'lodash';

export default {
  data() {
    return {
      customers: [],
      loading: true,
      balance: 0.0,
      search: "",
      creditTotal: 0.0,
      custSelected: 0,
      headers: [
        { text: "CID", value: "Cid", },
        {
          text: "Πελάτης",
          align: "start",
          //sortable: false,
          value: "Name",
          width: "30%",
        },
        
        //{ text: "ΑΦΜ", value: "BillingAfm" },
        { text: "Διεύθυνση", value: "Address" },
        { text: "Τηλέφωνο", value: "Telephone" },
        { text: "Υπόλοιπο", value: "Balance", align: "end" },
        { text: "Actions", value: "actions", sortable: false },
        //{ text: '', value: 'data-table-expand' },
      ],
    };
  },
  async created() {
    // GET request using fetch with async/await
    try {
      const response = await this.$api.get("/customers/", {params: {'non-billing': true}});
      this.customers = response.data;
      // const resp = await this.$api.get("/balance");
      this.balance = _sumBy(this.customers, 'Balance');
      this.loading = false;
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    creditBalance() { if (this.custSelected >0) return this.tocurr(this.creditTotal);
    return this.tocurr(this.balance);
    }
  },
  methods: {
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    itemSelected(selected) {
      if (selected.value) {
        this.creditTotal += selected.item.balance.balance;
        this.custSelected += 1;
      } else {
        this.creditTotal -= selected.item.balance.balance;
        this.custSelected -= 1;
      }
    },
    itemSelectAll(selected) {
      if (selected.value) {
        this.creditTotal = this.sumBalance(selected.items);
        this.custSelected = selected.items.length;
      } else {
        this.creditTotal = 0;
        this.custSelected = 0;
      }
    },
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('customer/'+item.customer_id)
    },
    sumBalance(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.balance.balance || 0), 0);
    },
    sortBy(prop) {
      this.customers.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    },
    getColor(status) {
      if (status === "complete") return "green";
      else if (status === "overdue") return "red";
      else return "";
    },
    async getBook(customer) {
      // let color = window.confirm("Χρωματισμός γραμμών");
      let color = true;
      const response = await this.$api.get('/'+customer+'/export',
          { responseType: "blob",
            params: {coloured: color}});
      let url = window['URL'].createObjectURL(response.data)
      var a = document.createElement('a')
      a.href = url
        a.download = customer + ' - ΚΑΡΤΕΛΑ ΠΕΛΑΤΗ.xlsx';
      a.click()
      a.remove()
      setTimeout(() => window.URL.revokeObjectURL(url), 100)
    }
  },
};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}
</style>
